import { inject, Injectable, Injector } from "@angular/core";
import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";
import { AuthService } from "src/app/pages/auth";
import { AuthUtilitiesService } from "src/app/pages/auth/services/auth-utilities.service";

export const httpClientInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  const apiUrl = environment.apiUrl;
  const loginService = injector.get(AuthUtilitiesService);

  // ❌ skip assets
  if (req.url.includes("assets/")) {
    return next(req);
  }

  // ✅ prepend API URL
  const reqUrl = apiUrl + req.url;

  // ✅ clone with base headers
  let modifiedReq = req.clone({
    url: reqUrl,
    setHeaders: {
      "Cache-Control": "no-cache, no-store, must-revalidate",
    },
  });

  // ✅ add Authorization header if token exists
  const token = loginService.getToken();

  if (token) {
    modifiedReq = modifiedReq.clone({
      setHeaders: { Authorization: `${token}` },
    });
  }
  // ✅ handle response & errors
  return next(modifiedReq).pipe(
    map((event) => event),
    catchError((err) => {
      if (err instanceof HttpErrorResponse) {
        if (err.status === 401) {
          if (err.error.errors !== "Invalid username and password.") {
          }
          if (err.error.errors === "Authentication fail.") {
            localStorage.removeItem("auth-user");
          }
        }
        return throwError(() => err);
      }
      return throwError(() => err);
    }),
  );
};
